(function ($) {
  "use strict";

  /***********************/
  /*******CATALOGUE*******/
  /***********************/

  var isColorLoaded = false;
  window.addEventListener("globoFilterRenderCompleted", function (e) {
    var colorValue = $("#collectionColorGroup").val();

    if (colorValue) {
      if (!isColorLoaded) {
        isColorLoaded = true;
        $(document).ready(function () {
          if ($('a[title="' + colorValue + '"].checked').length <= 0) {
            toggleCheckboxFilter(546648, colorValue);
          }
          $(".globo-selected-items-wrapper").remove();
          $(".spf-product__info").remove();
          $('div[data-filter-id="546648"]').hide();
        });
      } else {
        $(".globo-selected-items-wrapper").remove();
        $(".spf-product__info").remove();
        $('div[data-filter-id="546648"]').hide();
      }
    } else if (typeof isSeparateColors !== 'undefined' && isSeparateColors === "TRUE") {
    
        $(".spf-product__info").remove();
    }

    var nbLi = document.querySelectorAll("#gf-products li").length;
    setTimeout(function () {
      $(".nbr_product").text(nbLi);
    }, 1000);

    if (nbLi > 4) {
      $("#ProductGridContainer .cms1-body").remove();
      $("#gf-products li:eq(3)").after($("#cms1").html());
    }
    if (nbLi > 17) {
      $("#ProductGridContainer .cms2-body").remove();
      $("#gf-products li:eq(19)").after($("#cms2").html());
    }
  });

  $(document).ready(function () {
    if ($(".gf-filter-trigger").length <= 0) {
      var nbLi = document.querySelectorAll(
        "#ProductGridContainer ul article"
      ).length;
      setTimeout(function () {
        $(".nbr_product").text(nbLi);
      }, 1000);

      if (nbLi > 4) {
        $("#ProductGridContainer .cms1-body").remove();
        $("#ProductGridContainer ul article:eq(3)").after($("#cms1").html());
      }
      if (nbLi > 17) {
        $("#ProductGridContainer .cms2-body").remove();
        $("#ProductGridContainer ul article:eq(19)").after($("#cms2").html());
      }
    }
  });

  $(document).ready(function () {
    Array.from(
      document.querySelectorAll("variant-radios-configurable").values()
    ).forEach((item) => {
      item.updateOptions();
      item.updateMasterId();

      item.updatePickupAvailability();
      item.removeErrorMessage();
      item.updateMedia();
      item.updateURL();
      item.updateVariantInput();
      item.renderProductInfo();
      item.updateShareUrl();
      $("#product_id").closest("form").trigger("change");
    });
  });

  /***************************/
  /******* scrollToTop *******/
  /***************************/
  function scrollToTop() {
    var $scrollUp = $("#BackToTop"),
      $lastScrollTop = 0,
      $window = $(window);

    $window.on("scroll", function () {
      var st = $(this).scrollTop();
      if (st > $lastScrollTop) {
        $scrollUp.css({ bottom: "-110px" });
      } else {
        if ($window.scrollTop() > 200) {
          $scrollUp.css({ bottom: "110px" });
        } else {
          $scrollUp.css({ bottom: "-110px" });
        }
      }
      $lastScrollTop = st;
    });

    $scrollUp.on("click", function (evt) {
      $("html, body").animate({ scrollTop: 0 }, 600);
      evt.preventDefault();
    });
  }
  scrollToTop();

  /******************************************/
  /*********** Slider Push Homepage *********/
  /******************************************/
  $(".sliderPush").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    fade: true,
    autoplay: true,
    adaptiveHeight: true,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
        },
      },
    ],
  });

  /************************************/
  /*********** Slider Product *********/
  /************************************/
  if ($(window).width() < 767) {
    $(".slider-product").slick({
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
      ],
    });
    /******* slider-look ********/
    var numProduct = $(".product-list .slider-look .product-card").length;
    if (numProduct > 2) {
      $(".slider-look").slick({
        centerMode: true,
        centerPadding: "90px",
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: "90px",
              slidesToShow: 1,
            },
          },
        ],
      });
    } else {
      $(".product-list .slider-look").css("display", "flex");
    }

    /******* slider-shipping-date ********/
    $(".slider-shipping-date").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      dots: true,
      arrows: false,
    });
  }

  /*** Slick ***/
  $(".slick").slick();

  $(".product-single .product__media-list.slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    prevArrow: $(".prev"),
    nextArrow: $(".next"),
    asNavFor: ".slider-nav",
  });
  $(".product-single .product__media-list.slider-nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
  });

  /******************************************/
  /*********** Slider Mix and Match *********/
  /******************************************/
  if ($(window).width() < 767) {
    $(".slider-mixmatch").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        slidermixmobile(
          $(slick.$slides.get(currentSlide)).find(
            ".slider-nav:not(.slick-initialized)"
          )
        );
      }
    );
  }

  $(".slider-mixmatch").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    touchMove: false,
    swipe: false,
    infinite: true,
    prevArrow: $(".btn-mixmatch .prev-arrow"),
    nextArrow: $(".btn-mixmatch .next-arrow"),
  });
  if ($(".slider-mixmatch").length > 0) {
    if ($(window).width() < 767) {
      $(".image-with-text .grid .slider-nav").css("display", "flex");
      var currentSlide = $(".slider-mixmatch").slick("slickCurrentSlide");
      slidermixmobile(
        $($(".slider-mixmatch").get(0).slick.$slides.get(currentSlide)).find(
          ".slider-nav:not(.slick-initialized)"
        )
      );
    }
  }

  function slidermixmobile(el) {
    el.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      centerMode: true,
      centerPadding: "90px",
      slidesToShow: 1,
      infinite: el.find(".item").length < 3 ? false : true,
      focusOnSelect: true,
    });
  }

  /***************************************/
  /*********** Hover Menu Header *********/
  /***************************************/
  if ($(window).width() > 992) {
    if (!$("body").hasClass("hover-header")) {
      $(".list-menu")
        .mouseover(function () {
          $("body").addClass("hover-header");
        })
        .mouseout(function () {
          $("body").removeClass("hover-header");
        });
    }
  }

  /*********************************/
  /*********** Menu Mobile *********/
  /*********************************/
  if ($(window).width() < 992) {
    document.addEventListener("DOMContentLoaded", () => {
      const menu = new MmenuLight(document.querySelector("#menu"));

      const navigator = menu.navigation();
      const drawer = menu.offcanvas();

      document
        .querySelector('[data-lk="#menu"]')
        .addEventListener("click", (evnt) => {
          evnt.preventDefault();
          drawer.open();
          $(".close-menu").insertBefore($("#menu"));
        });
      document
        .querySelector(".mm-ocd__content .close-menu")
        .addEventListener("click", (evnt) => {
          evnt.preventDefault();
          drawer.close();
        });
    });
  }

  /*****************************************/
  /****** Offcanvas Broderie Product *******/
  /*****************************************/
  if ($("#broderie").length > 0) {
    document.addEventListener("DOMContentLoaded", () => {
      const broderie = new MmenuLight(document.querySelector("#broderie"));

      const navigator = broderie.navigation();
      if ($(window).width() < 767) {
        var drawer3 = broderie.offcanvas({
          position: "left",
        });
      } else {
        var drawer3 = broderie.offcanvas({
          position: "right",
        });
      }

      document
        .querySelector('a[href="#broderie"]')
        .addEventListener("click", (evnt3) => {
          evnt3.preventDefault();
          drawer3.open();
        });
      document
        .querySelector(".mm-ocd__content .close-broderie")
        .addEventListener("click", (evnt3) => {
          evnt3.preventDefault();
          drawer3.close();
        });
    });
  }

  /************************************/
  /*********** HOVER MEGAMENU *********/
  /************************************/
  $(".header .list-menu .menuItem").hover(
    function () {
      $(".header .mega-menu").addClass("hover-menu");
    },
    function () {
      $(".header .mega-menu").removeClass("hover-menu");
    }
  );
  $(".header .close-menu-hover").click(function () {
    $(".header .mega-menu").removeClass("hover-menu");
  });

  /******************************/
  /*********** BRODERIE *********/
  /******************************/
  $(document).on("click", "[data-type]", function () {
    var broderieId = $(this).data("broderieId");
    var productUrl = [];

    $(`[data-broderie-id="${broderieId}"]`).each(function () {
      productUrl.push($(this).data("url"));
    });
    let uniqueUrl = [...new Set(productUrl)];
    $.ajax({
      type: "POST",
      dataType: "json",
      url: uniqueUrl[0],
      cache: false,
      success: function (response) {
        $.ajax({
          type: "POST",
          dataType: "json",
          url: uniqueUrl[1],
          cache: false,
          success: function (response) {
            window.location.href = "/cart";
          },
        });
      },
    });
  });

  $(document).on("click", "[data-taie]", function () {
    if ($(this).data("taie") == 2) {
      $(".text-broderie-2").css("display", "block");
      $(".broderie_product_id").val($("#taie-2").val());
    }
    if ($(this).data("taie") == 1) {
      $(".text-broderie-2").css("display", "none");
      $(".broderie_product_id").val($("#taie-1").val());
    }
  });
  $("#broderie .typography").on("click", function (evt) {
    $("#broderie .selectedTypography").text(evt.target.defaultValue);
    $("#broderie .image-font ").css("display", "none");
    $("#broderie .image-font." + evt.target.defaultValue).css(
      "display",
      "block"
    );
  });
  $("#broderie .color").on("click", function (evt) {
    $("#broderie .selectedColor").text(evt.target.defaultValue);
  });

  $("#postionSelectType3").change(function () {
    if (this.value == "Sur le cœur") {
      $(".inputSize").attr({ maxlength: 5 });
      $(".inputSize").val($(".inputSize").val().substring(0, 5));
      $(".caraNbr").text("initiales recommandées, " + 5);
    } else if (this.value == "Sur le poignet") {
      $(".inputSize").attr({ maxlength: 2 });
      $(".inputSize").val($(".inputSize").val().substring(0, 2));
      $(".caraNbr").text(2);
    } else {
      $(".inputSize").attr({ maxlength: 10 });
      $(".inputSize").val($(".inputSize").val().substring(0, 10));
      $(".caraNbr").text(10);
    }
  });

  $("#postionSelectType4").change(function () {
    if (this.value == "Sur le cœur") {
      $(".inputSize").attr({ maxlength: 2 });
      $(".inputSize").val($(".inputSize").val().substring(0, 2));
      $(".caraNbr").text("initiales recommandées, " + 2);
    } else if (this.value == "Sur le poignet") {
      $(".inputSize").attr({ maxlength: 2 });
      $(".inputSize").val($(".inputSize").val().substring(0, 2));
      $(".caraNbr").text(2);
    } else {
      $(".inputSize").attr({ maxlength: 8 });
      $(".inputSize").val($(".inputSize").val().substring(0, 8));
      $(".caraNbr").text(8);
    }
  });

  //$("#product-form-broderier input[type='text'][placeholder='Lorem ipsum elo']").on('input', function (event) {
  //  $(this).val($(this).val().substring(0, $(this).prop('maxlength')));
  //})

  $(
    "#product-form-broderier input[type='text'][placeholder='Lorem ipsum elo']"
  ).on("keydown", function (event) {
    var msg = document.getElementById("showmsg");
    var targetSize = event.target.value.length;
    var self = $(this);

    requestAnimationFrame(function () {
      var target = event.target;
      var defferedTargetSize = event.target.value.length;

      if (
        defferedTargetSize >= event.target.getAttribute("maxlength") &&
        defferedTargetSize === targetSize
      ) {
        msg.style.display = "block";
      } else {
        msg.style.display = "none";
      }

      if (event.target.value.length > event.target.getAttribute("maxlength")) {
        self.val(self.val().substring(0, self.prop("maxlength")));
      }
    });
  });

  $(
    "#product-form-broderier input[type='text'][placeholder='Lorem ipsum elo']"
  ).on("blur", function (event) {
    const msg = document.getElementById("showmsg");
    var target = event.target;
    var targetSize = event.target.value.length;

    if (targetSize > event.target.getAttribute("maxlength")) {
      msg.style.display = "block";
    } else {
      msg.style.display = "none";
    }
  });

  /************************************/
  /*********** PRODUCT CONFIG *********/
  /************************************/
  $(document).on("click", "[data-product]", function () {
    var addButton = document.getElementsByName("add");
    if (!addButton) return;
    addButton.forEach((element) => {
      element.removeAttribute("disabled");
      $(".add-text").text("Ajouter au panier");
    });
    var idVariant = $(this).data("product");
    $(`[data-variant="${idVariant}"]`).click();
    $(`.product__media-wrapper`).addClass("visually-hidden");
    $(`[data-lightgallery="${idVariant}"]`).removeClass("visually-hidden");
    var media = $(this).data("media");
    $(`li[data-media="${media}"]`).parent().parent().attr("data-media");
    var index = $(`li[data-media="${media}"]`)
      .parents(".slick-slide")
      .attr("data-slick-index");
    $(".product__media-list.slider-for").slick("slickGoTo", index);
    $(".product__media-list.slider-for").slick("refresh");
    $(".product__media-list.slider-nav").slick("refresh");
    $("[data-slick]").slick("resize");
  });

  /**********************************/
  /*********** obfusqués JS *********/
  /**********************************/
  $(document).on("click", "[data-product-color]", function (e) {
    e.stopPropagation();
    e.preventDefault();
    var element = $(`a[data-url-product="${$(this).data("product-color")}"]`);
    location.href = element.attr("href");
  });

  $(document).on("click", ".trigger-price-update", function () {
    var variantPrice = $(this).data("price");
    var targetId = $(this).data("target-id");
    $(".price-item-" + targetId).html(variantPrice);
    $(".price-label-item-" + targetId).html("");
  });

  /*** Light Gallery ***/

  lightGallery(document.getElementById("lightgallery"), {
    plugins: [lgZoom],
    selector: ".product__media-list.slider-for .product__media-item",
    speed: 500,
    enableDrag: false,
    counter: false,
    download: false,
    showCloseIcon: true,
    showCloseIcon: true,
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
    },
  });

  /**********************************/
  /*********** Show fiche product by varinat catalog listing  *********/
  /**********************************/
  $("[data-lk]").on("click", function () {
    try {
      location.href = atob($(this).data("lk"));
    } catch {
      return false;
    }
  });
  /********************************/
  /******* show plucs color *******/
  /********************************/

  window.addEventListener("globoFilterRenderCompleted", function (e) {
    $(".spf-product__swatchs").each(function () {
      $(this)
        .find(".spf-product__swatch")
        .each(function (key, val) {
          if ($(window).width() > 992 && key >= 12) {
            $(this).addClass("hidden");
            $(this).parent().find("[data-plus-color]").removeClass("hidden");
          }

          if ($(window).width() > 767 && $(window).width() <= 991 && key >= 6) {
            $(this).addClass("hidden");
            $(this).parent().find("[data-plus-color]").removeClass("hidden");
          }

          if ($(window).width() <= 767 && key >= 3) {
            $(this).addClass("hidden");
            $(this).parent().find("[data-plus-color]").removeClass("hidden");
          }
        });
    });
  });

  $(document).on("click", "[data-plus-color]", function () {
    $(this)
      .parents(".spf-product__swatchs")
      .find(".spf-product__swatch")
      .removeClass("hidden");
    $(this)
      .parents(".variant")
      .find("span:not([data-plus-color])")
      .removeClass("hidden");
    $(this).remove();
  });

  const productsCard = document.querySelectorAll(".product-card");
  productsCard.forEach((product) => {
    var variant = product.querySelector(".variant");
    var colors = variant.querySelectorAll(
      ":scope > span:not([data-plus-color])"
    );

    $(colors).each(function (key, val) {
      if ($(window).width() > 992 && key >= 12) {
        $(this).addClass("hidden");
        $(this).parent().find("[data-plus-color]").removeClass("hidden");
      }

      if ($(window).width() > 767 && $(window).width() <= 991 && key >= 6) {
        $(this).addClass("hidden");
        $(this).parent().find("[data-plus-color]").removeClass("hidden");
      }

      if ($(window).width() <= 767 && key >= 3) {
        $(this).addClass("hidden");
        $(this).parent().find("[data-plus-color]").removeClass("hidden");
      }
    });
  });

  const productsCardSlider = document.querySelectorAll(
    ".slider-look .product-card"
  );
  productsCardSlider.forEach((product) => {
    var variantSlider = product.querySelector(".variant");
    var colorsSlider = variantSlider.querySelectorAll(
      ":scope > span:not([data-plus-color])"
    );

    $(colorsSlider).each(function (key, val) {
      if (key >= 3) {
        $(this).addClass("hidden");
        $(this).parent().find("[data-plus-color]").removeClass("hidden");
      }
    });
  });

  /********************************/
  /******* LOGO DOOFINDER *********/
  /********************************/
  $(".header-wrapper .header__search").on("click", function () {
    setTimeout(function () {
      var logosearch = document.getElementById("logo-searchbar");
      var doofinderContent = document.querySelector(
        ".dfd-fullscreen .dfd-header"
      );
      doofinderContent.prepend(logosearch);
      $("#logo-searchbar").css("display", "block");
    }, 2000);
  });

  /**************************************/
  /******* Scroll Mix and match *********/
  /**************************************/

  if ($(".content-text").length > 0) {
    $(".content-text").insertBefore($(".footer"));
    $(".content-text").css("display", "block");
  }
  // if ($('.stamped-review-header .stamped-starratings').length > 0){
  // 	$(".stamped-review-header .stamped-starratings").insertBefore($(".stamped-review-body"));
  // }

  $(".product-form #submitProduct").on("click", function () {
    document.getElementById("submitProduct").innerText = "Produit ajouté !";
  });

  $(document).ready(function () {
    var intervalId = setInterval(function () {
      var mainBadge = document.querySelector('.stamped-main-badge');
      if (!mainBadge) {
        return clearInterval(intervalId);
      }
      var reviews = mainBadge.querySelector('span')
      if (reviews) {
        clearInterval(intervalId);
        if (reviews.getAttribute('data-rating') === '0.0') {
          mainBadge.style.display = "none";
        }
      }
    }, 200);
  });
})(jQuery);
